export default __webpack_public_path__ + "static/media/map.1d287b37.png";